module.exports = __webpack_public_path__ + "static/img/DrAnilBhansali.6df3322.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/DrAnilBhansali.png
// module id = YirF
// module chunks = 1